import React, { Component } from "react";

import { Form } from "reactstrap";
import { Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import validate from "validate.js";

import api from "../../services/Admin";

import Aux from "../../components/hoc/Aux";
import IconName from "../../assets/img/alerta-spa.png";
import ModalAttention from "../../components/hoc/ModalAttention";
import AdminSession from "../../libs/AdminSession";

export default class Login extends Component {
  state = {
    loggedIn: false,
    buttonOk: false,
    modal: false,
    err401: false,
    errGeral: false,
  };

  Capt = (value) => {
    if (value) {
      this.setState({ buttonOk: true });
    }
  };

  validateForm = (values) => {
    const constraints = {
      username: { presence: true, numericality: true, length: { minimum: 11, maximum: 11 } },
      password: { presence: true, length: { minimum: 6 } },
    };

    if (validate(values, constraints) !== undefined) {
      this.setState({ modal: true, err401: true });
      return false;
    }

    return true;
  };

  handleLogin = (event) => {
    event.preventDefault();

    var values = {
      username: this.email.value,
      password: this.passwd.value,
    };

    if (this.validateForm(values)) {
      api
        .loginRequest(values)
        .then(async (resp) => {
          // Set TOKEN
          const { access_token } = resp.data;

          const User = {
            cpf: resp.data.user.cpf,
            email: resp.data.user.email,
            nome: resp.data.user.nome,
            orgao: resp.data.user.orgao,
          };

          AdminSession.setData(access_token, User);

          this.setState({ loggedIn: true });
        })
        .catch((err) => {
          let error = err.response || 1;
          if (error.status === 401) {
            this.setState({ modal: true, err401: true });
          } else {
            this.setState({ modal: true, errGeral: true });
          }
        });
    }
  };

  onModal = () => {
    this.setState({ modal: !this.state.modal, err401: false, errGeral: false });
  };

  render() {
    // let captcha;
    if (this.state.loggedIn) return <Redirect to="/admin/dashboard" />;
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-8 col-lg-5 mb-3">
            <Aux>
              <div className="container ContainerIconAlerta">
                <div className="DivIconAlerta2">
                  <img src={IconName} width="80%" height="80%" alt="" />
                </div>
              </div>
              <div className="Login">
                <Form className="form-admin-login form-row">
                  <div className="form-group col-md-12">
                    <div className="input-group mb-3 ">
                      <div className="input-group-prepend ">
                        <span className="input-group-text" id="basic-addon1">
                          <i className="fas fa-user"></i>
                        </span>
                      </div>
                      <input
                        type="cpf"
                        className="form-control "
                        placeholder="Informe seu cpf"
                        aria-label="Informe seu cpf"
                        aria-describedby="basic-addon1"
                        ref={(ref) => (this.email = ref)}
                        onChange={this.verifyEmail}
                        id="inputUsernameEmail"
                      />
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <i className="fas fa-lock"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Digite sua senha"
                        aria-label="Digite sua senha"
                        aria-describedby="basic-addon1"
                        ref={(ref) => {
                          this.passwd = ref;
                        }}
                        onChange={this.verifyEmail}
                        id="inputPassword"
                      />
                    </div>
                  </div>
                  <div className="form-group col-md-12 d-flex justify-content-center">
                    <ReCAPTCHA
                      ref={(el) => {
                        this.captcha = el;
                      }}
                      size="normal"
                      sitekey="6LdF2XYUAAAAAKyH6cV6_6bAIHlu8LBgIPw5E2jj"
                      onChange={this.Capt}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <button
                      className="btn btn-secondary button-entrar"
                      type="submit"
                      onClick={this.handleLogin}
                    >
                      <span>Entrar</span>
                    </button>
                  </div>
                </Form>
              </div>
              {/* <div
                className=""
                style={{
                  textAlign: "center",
                  bottom: "-580px",
                  marginTop: "5%",
                  right: "5%",
                  marginLeft: "1%",
                }}
              ></div> */}
            </Aux>
          </div>
        </div>
        <ModalAttention
          title="Atenção"
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.onModal}
        >
          {this.state.err401 ? <p style={{ color: "black" }}>Usuario ou senha incorretas</p> : null}
          {this.state.errGeral ? (
            <p style={{ color: "black" }}>
              Não foi possivel acessar a autenticação do sistema, favor entrar em contato com o
              administrador do sistema.
            </p>
          ) : null}
        </ModalAttention>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Index.js